<template>
  <current-menu :locale="currentLocale" @language="setLanguage" />
</template>

<script>
import CurrentMenu from './CurrentMenu';

export default {
  components: { CurrentMenu },
  computed: {
    currentLocale() { return this.$i18n.locale().split('-')[0] === 'es' ? 'es' : 'en'; },
  },
  watch: {
    '$route.query.lang'(lang) { if (lang === 'es' || lang === 'en') this.applyLanguage(lang); },
  },
  created() {
    let saved;
    try { saved = window.localStorage.getItem('taj-menu-language'); } catch (error) { /* Private browsing may block storage. */ }
    const requested = this.$route.query.lang;
    this.applyLanguage(requested === 'es' || requested === 'en' ? requested : (saved === 'es' || saved === 'en' ? saved : this.currentLocale));
  },
  beforeDestroy() { document.title = 'Taj Mahal Sevilla'; },
  methods: {
    applyLanguage(lang) {
      this.$i18n.set(lang);
      document.documentElement.lang = lang;
      document.title = (lang === 'es' ? 'Carta' : 'Menu') + ' · Taj Mahal Sevilla';
    },
    setLanguage(lang) {
      this.applyLanguage(lang);
      try { window.localStorage.setItem('taj-menu-language', lang); } catch (error) { /* Language still works without storage. */ }
      if (this.$route.query.lang !== lang) this.$router.replace({ path: '/menu', query: { ...this.$route.query, lang } });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/MenuPage.vue